import axios from 'axios';
import { createErrorFromAxiosUserMessageError } from 'api/utilities';
import { BANKS_URL } from 'api/constants';

export async function getBanks() {
  try {
    return await axios.get(BANKS_URL);
  } catch (e) {
    throw createErrorFromAxiosUserMessageError(e);
  }
}
